import React, {PureComponent} from 'react';
import {connect} from 'react-redux';
import {pushEdapEvent} from '../../../utils/edap';
import {getPrefix} from '../../../utils/urls';
import {CardCarousel} from '../../common/carousel/Carousel';
import {RatioCard} from '../../common/carousel/Card';
import determineIfMobile from '@homeaway/react-determine-if-mobile';
import {TABLET_BREAKPOINT} from '../../../utils/constants';

function handleClick(lbsId) {
    const eventData = {
        actionlocation: 'city-descendant-linkpile',
        eventlbsuuid: lbsId,
        eventRefinements: 'locality'
    };

    return () => pushEdapEvent('destination.link.click', eventData, {delayProcessing: true});
}

function replaceTemplateString(template, res) {
    return (template || '').replace('${templateId}', `carousel-${res}`);
}

function createRatioCard({payload, mounted, isMobile}) {
    return (props, index) => {
        const {simpleName, url, lbsId, title, subheading} = props;
        const data = payload.find((p) => p.key === lbsId) || {};
        const mkSrc = replaceTemplateString.bind(null, data.urlTemplate);

        const horizontalScrollContainer = {
            event: isMobile ? 'scroll' : 'transitionend',
            element: isMobile ? '.popular-destinations-ratio-cards .CardCarousel__container--scrolling' : '.popular-destinations-ratio-cards .CardCarousel__content'
        };

        if (data.urlTemplate || !mounted) {
            return (
                <RatioCard
                    altText={simpleName}
                    footer={subheading}
                    getImageUrl={mkSrc}
                    horizontalScrollContainer={horizontalScrollContainer}
                    isMobile={isMobile}
                    key={index}
                    linkRel={null}
                    onClick={handleClick(lbsId)}
                    path={url}
                    subtitle={''}
                    title={title}
                />
            );
        }

        return null;
    };
}


export class PopularDestinationsComponent extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            mounted: false,
            payload: []
        };
    }

    componentDidMount() {
        const {popularDestinations} = this.props;
        if (popularDestinations.length) {
            const lbsIds = popularDestinations.map((p) => `ids=${p.lbsId}`).join('&');
            fetch(`/${getPrefix()}/api/images?${lbsIds}`, {
                credentials: 'same-origin'
            })
                .then((response) => response.json())
                .then((payload) => {
                    if (payload && Array.isArray(payload)) {
                        // TODO: how do we log errors here?
                        this.setState({mounted: true, payload});
                    }
                });
        }
    }

    render() {
        const {
            isMobile,
            popularDestinations,
            cityCarouselTitle
        } = this.props;
        const {payload, mounted} = this.state;
        if (popularDestinations.length < 3) {
            return null;
        }

        const cards = popularDestinations
            .map(createRatioCard({payload, mounted, isMobile}))
            .filter((x) => !!x)
            .slice(0, 6);

        if (cards.length < 4) {
            return null;
        }
        return (<div className="container module module--no-padding popular-destinations-ratio-cards">
            <CardCarousel titleMessage={cityCarouselTitle}>
                {cards}
            </CardCarousel>
        </div>);
    }
}

export function mapStateToProps({destination, config}) {
    const {locality, details} = destination;
    return {
        popularDestinations: locality.carousel || [],
        simpleName: (details && details.simpleName) || '',
        isMobile: config.isMobile,
        cityCarouselTitle: locality.title
    };
}

export const PopularDestinations = connect(mapStateToProps)(determineIfMobile(PopularDestinationsComponent, TABLET_BREAKPOINT));
